import WithMotion from 'components/withMotion';
import Table from './Table';

function PageContainer() {
  return <Table shouldCreateDisabled={true} searchOptions={{}} />;
}

export default WithMotion(PageContainer);
